import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EditTemplateMarketingFeaturedCategoryMenuCombinedLoadingOptsViewModel } from './edit-template-marketing-featured-category-menu-combined-loading-opts-view-model';
import { EditTemplateMarketingMenuComponent } from '../edit-template-marketing-menu.component';
import { EditTemplateMarketingFeaturedCategoryMenuViewModel } from './edit-template-marketing-featured-category-menu-view-model';
import { EditFeaturedCategoryMenuViewModel } from '../../../../../menu/components/edit-menu/edit-marketing-menu/edit-featured-category-menu/edit-featured-category-menu-view-model';

@Component({
  selector: 'app-edit-template-marketing-featured-category-menu',
  templateUrl: './edit-template-marketing-featured-category-menu.component.html',
  styleUrls: ['./edit-template-marketing-featured-category-menu.component.scss'],
  providers: [
    EditTemplateMarketingFeaturedCategoryMenuViewModel,
    EditFeaturedCategoryMenuViewModel,
    EditTemplateMarketingFeaturedCategoryMenuCombinedLoadingOptsViewModel
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EditTemplateMarketingFeaturedCategoryMenuComponent extends EditTemplateMarketingMenuComponent {
  constructor(
    public override viewModel: EditTemplateMarketingFeaturedCategoryMenuViewModel,
    public override combinedLoadingOptsViewModel: EditTemplateMarketingFeaturedCategoryMenuCombinedLoadingOptsViewModel
  ) {
    super(viewModel, combinedLoadingOptsViewModel);
  }
}
